import React, { useState } from 'react';
import { ContButtonActions } from './styles';
import { CriaPedidoProps, Anexos } from './props';
import { Table, Upload, Button, message, Spin, Tooltip, notification, Popconfirm } from 'antd';
import { ColumnType } from 'antd/lib/table';
import mask from '../../../../../../utils/mask';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { SKW_AUTH, SKW_PREFIX, SKW_URL } from '../../../../../../utils/constants';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import api from '../../../../../../service/api';
import { RcFile } from 'antd/lib/upload';
import ShowItem from './components/ShowItem';
import TitleTable from 'components/TitleTable';

const CriaPedidoEntrega: React.FC<CriaPedidoProps> = ({ data, setData, label }) => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const [nuNota, setNuNota] = useState<number>(0);
  const [loading, setloading] = useState<boolean>(false);
  const [anexos, setAnexos] = useState<Anexos[]>([]);
  const [base64, setBase64] = useState<string>('');

  const props = {
    action: `${SKW_URL}/upload?serviceName=${SKW_PREFIX}enviarDocumentoNota&accessKey=${SKW_AUTH}`,
    onChange(info: any) {
      try {
        if (info.file.status === 'done') {
          enviarDocumentoParceiro(info.fileList[0].response[0].filekey, info?.file?.name);
        }
      } catch (error) {
        message.error(`Upload do arquivo falhou.`);
      }
    },
    showUploadList: false,
  };

  const getBase64 = (file: RcFile): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => reject(error);
    }).then((res: any) => {
      setBase64(res);
      return res;
    });
  };

  const beforeUpload = (file: RcFile) => {
    const isLt5M = file.size / 1024 / 1024 <= 5;
    if (!isLt5M) {
      message.error('Arquivo não pode ser maior que 5MB!');
    }
    getBase64(file);
    return isLt5M;
  };

  const openNotification = (message: string) => {
    notification.info({
      placement: 'bottomRight',
      message: message,
    });
  };

  const enviarDocumentoParceiro = (key: string, name: string) => {
    try {
      setloading(true);
      api
        .post(`call?serviceName=${SKW_PREFIX}enviarDocumentoNota&token=${token}`, {
          chave: key,
          nuNota: nuNota,
          descricao: `Anexo NF-${nuNota}`,
          nomeArquivo: name,
        })
        .then((res) => {
          Swal.fire({
            title: `Enviado com sucesso!`,
            html: '',
            icon: 'success',
            confirmButtonText: 'OK',
            showConfirmButton: false,
            timer: 1500,
          });
          setloading(false);
          listaAnexos(nuNota);
        })
        .catch((err) => {
          Swal.fire({
            title: `Opss!`,
            html: 'Não foi possível enviar o anexo, por favor tente anexar novamente!',
            icon: 'error',
            showConfirmButton: true,
          });
          setloading(false);
        });
    } catch (error) {}
  };

  const listaAnexos = (nuNota: number) => {
    api
      .post(`call?serviceName=${SKW_PREFIX}listaAnexos&token=${token}`, {
        nunota: nuNota,
      })
      .then((res) => {
        const notas = anexos.map((item: any) => item.nuNota.toString());
        if (notas.includes(nuNota.toString())) {
          anexos.splice(notas.indexOf(nuNota.toString()), 1);

          setAnexos([
            ...anexos,
            {
              name: res?.data?.anexos[0]?.arquivo.toString(),
              nuNota: nuNota.toString(),
              base64: base64.toString(),
            },
          ]);
        } else
          setAnexos([
            ...anexos,
            {
              name: res?.data?.anexos[0]?.arquivo.toString(),
              nuNota: nuNota.toString(),
              base64: base64.toString(),
            },
          ]);
      })
      .catch((err) => {
        openNotification('Ops, não foi possível anexar o arquivo!');
      });
  };

  const handleDeleteItem = (nuNota: number) => {
    setloading(true);
    api
      .post(`call?serviceName=${SKW_PREFIX}excluiPedido&token=${token}`, {
        nunota: nuNota,
      })
      .then((res: any) => {
        data.splice(
          data.findIndex((item: any) => item.nuNota === nuNota),
          1
        );
        setData([...data]);

        setloading(false);
        openNotification('Documento excluído com sucesso!');
      })
      .catch((error: any) => {
        setloading(false);
        openNotification(`Ops, não foi possível excluir o documento!`);
      });
  };

  const handleDeleteAnexo = (nuNota: any) => {
    api
      .post(`call?serviceName=${SKW_PREFIX}deletaAnexoPortal&token=${token}`, {
        nunota: nuNota,
      })

      .then((response) => {
        anexos.splice(anexos.map((item: any) => item.nuNota).indexOf(nuNota), 1);
        setAnexos([...anexos]);
        openNotification(`Anexo excluído com sucesso!`);
      })
      .catch((error) => {
        openNotification('Erro ao tentar excluir anexo!');
      });
  };

  const columns: ColumnType<any>[] = [
    {
      title: <TitleTable>N° da NF</TitleTable>,
      dataIndex: label === 'entrega' ? 'numNota' : 'numPedido',
      key: label === 'entrega' ? 'numNota' : 'numPedido',
      width: 120,
      render: (text: any, record: any) => {
        return text ? text : 'Não informado';
      },
    },

    {
      title: <TitleTable>Fornecedor</TitleTable>,
      dataIndex: 'fornecedor',
      key: 'fornecedor',
      render: (text: any, record: any) => {
        return text ? mask('camelCase', text) : 'Não informado';
      },
    },

    {
      title: <TitleTable>Peso bruto</TitleTable>,
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      width: 150,
      render: (text: number = 0, record: any) => {
        return text ? <>{mask('peso', text)}</> : 'Não informado';
      },
    },

    {
      title: <TitleTable>Valor</TitleTable>,
      dataIndex: 'valor',
      key: 'valor',
      width: 150,
      render: (text: number = 0) => {
        return text ? mask('currency', text) : 'Não informado';
      },
    },

    {
      title: <TitleTable>Ações</TitleTable>,
      dataIndex: 'acoes',
      key: 'acoes',
      render: (text, record) => {
        return (
          <ContButtonActions>
            <Upload
              {...props}
              maxCount={1}
              multiple={false}
              accept=".pdf, .doc, .xls, .xlsx, .csv, .png, .jpg, .jpeg, .rar, .zip, .xml, .txt"
              beforeUpload={beforeUpload}
            >
              <Button
                type="default"
                onClick={() => setNuNota(record?.nuNotaPedido ?? record?.nuNota)}
                style={{ width: '25px', border: 'none' }}
                disabled={false}
                icon={
                  anexos
                    ?.map((item: any) => item['nuNota'])
                    ?.includes(record?.nuNota?.toString()) ? (
                    <Tooltip
                      title={anexos.map((item: any) => {
                        if (item?.nuNota === record?.nuNota.toString()) return item?.name;
                        return '';
                      })}
                    >
                      <UploadOutlined style={{ color: '#40A9FF' }} />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Anexar nota fiscal">
                      <UploadOutlined />
                    </Tooltip>
                  )
                }
              ></Button>
            </Upload>

            {label === 'entrega' && (
              <>
                <ShowItem
                  data={record}
                  handleDeleteItem={handleDeleteItem}
                  icon="show"
                  dataList={data}
                  setDataList={setData}
                  anexos={anexos}
                  setAnexos={setAnexos}
                  handleDeleteAnexo={handleDeleteAnexo}
                />
                <ShowItem
                  data={record}
                  handleDeleteItem={handleDeleteItem}
                  icon="edit"
                  dataList={data}
                  setDataList={setData}
                  anexos={anexos}
                  setAnexos={setAnexos}
                  handleDeleteAnexo={handleDeleteAnexo}
                />
                <Tooltip title="Excluir">
                  <Popconfirm
                    title="Tem certeza que deseja excluir esse item?"
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={() => handleDeleteItem(record.nuNota)}
                  >
                    <Button
                      type="default"
                      style={{ width: '25px', border: 'none' }}
                      disabled={false}
                      icon={<DeleteOutlined />}
                    ></Button>
                  </Popconfirm>
                </Tooltip>
              </>
            )}
          </ContButtonActions>
        );
      },
    },
  ];

  return (
    <>
      <Spin spinning={loading}>
        <Table
          rowKey={'numnote'}
          style={{ fontSize: 10, display: 'inline', fontWeight: 400 }}
          columns={columns}
          scroll={{ x: 700 }}
          size={'large'}
          pagination={false}
          dataSource={data}
          className="table"
          loading={loading}
        />
      </Spin>
    </>
  );
};

export default CriaPedidoEntrega;
